import React, { useState } from 'react';
import { isBlank, isNullOrUndefined } from '@utils/utils';
import LinkWithIcon from '@components/ringil3/Links/LinkWithIcon.tsx';
import SvgIconPlus from '@components/framework/orders/IconPlus.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';
import RingilTextArea from '@components/framework/input/RingilTextArea';

interface ComponentProps {
  note: string;
  onChanges: (value: string) => void;
  noteLabel?: string;
  maxLength?: number;
  dataTestIdButton?: string;
  dataTestIdInput?: string;
}

const InputNoteWithLink: React.FC<ComponentProps> = ({ note, noteLabel, onChanges, maxLength, dataTestIdButton, dataTestIdInput }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      {!open && isBlank(note) && <LinkWithIcon label={noteLabel} icon={<SvgIconPlus />} onClick={() => setOpen(true)} dataTestId={dataTestIdButton}></LinkWithIcon>}
      {(note || open) && (
        <Field label={noteLabel}>
          <RingilTextArea
            value={isNullOrUndefined(note) ? '' : note}
            onChange={v => onChanges(v)}
            rows={4}
            maxLength={maxLength}
            dataTestId={dataTestIdInput}
          />
        </Field>
      )}
    </div>
  );
};

export default InputNoteWithLink;
